@if (priority) {
  <nz-tag
    [ngClass]="priorityHelperService.setColor(priority, isTextBold)"
    [class.cursor-pointer]="isEditable"
    (click)="isEditable && openChangePriorityModal()"
  >
    {{ title }} {{ priority }}
  </nz-tag>
} @else {
  @if (isEditable) {
    <nz-tag
      [ngClass]="{ 'cursor-pointer border-dashed': isEditable }"
      [class.cursor-pointer]="isEditable"
      (click)="isEditable && openChangePriorityModal()"
    >
      @if (isEditable) {
        <span class="plus-size">+</span>
      }
      <span class="text-dark">
        {{
          isEditable
            ? ('activity.priority.add' | translate)
            : ('activity.priority.no_selection' | translate)
        }}
      </span>
    </nz-tag>
  } @else {
    <span>
      {{ !showNA ? ('general.n/a' | translate) : '' }}
    </span>
  }
}
